<template>
  <div>
    <!-- <ReachedStatus :item="item" @select-reached-info="selectReachedInfo" /> 
     -->

    <v-select
      v-model="progress_status"
      :items="progress_status_list"
      :class="['contact-v-select', potentialityClass]"
      @update:modelValue="updateProgressStatus"
      variant="outlined"
      hide-details
      placeholder="Select Progress Status"
    >
      <template #item="{ item }">
        <v-list-item @click="setValue(item)" style="padding: 0">
          <div
            :style="getPotentialityStyle(item)"
            class="w-100 pa-2 text-center"
          >
            {{ item.title }}
          </div>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>
<script>
// import ReachedStatus from "@/components/crm/leads/options/ReachedStatus.vue";
import { useLeadsStore } from "@/store/crm/useLeadsStore";
import apiClient from "@/core/buildRequest";

export default {
  props: ["item"],
  name: "ProgressCol",
  data() {
    return {
      progress_status: "",
      progress_status_list: ["New", "In Progress", "Recycled", "Dead"],
      leadStore: useLeadsStore(),
    };
  },
  computed: {
    potentialityClass() {
      switch (this.progress_status) {
        case "New":
          return "contact-v-select-prime";
        case "In Progress":
          return "contact-v-select-blue";
        case "Recycled":
          return "contact-v-select-orange";
        case "Dead":
          return "contact-v-select-red";
        default:
          return "";
      }
    },
  },
  methods: {
    setValue(item) {
      this.progress_status = item.title;
      this.updateProgressStatus();
    },
    // async selectReachedInfo(
    //   doctor_name,
    //   department_name,
    //   consultation_date,
    //   service
    // ) {
    //   this.reached_info.doctor_name = doctor_name;
    //   this.reached_info.department_name = department_name;
    //   this.reached_info.consultation_date = consultation_date;
    //   this.reached_info.service = service;
    // },
    getPotentialityStyle(item) {
      const value = typeof item === "string" ? item : item.title;
      const styles = {
        New: { color: "#1c6572", background: "#e9f8fc" },
        "In Progress": { color: "#0464bc", background: "#f5fafe" },
        Recycled: { color: "#c14a05", background: "#fefbf1" },
        Dead: { color: "#d91313", background: "#fef3f2" },
      };

      return {
        ...(styles[value] ?? {}),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "600",
      };
    },
    async updateProgressStatus() {
      try {
        await apiClient.post(
          `/leads-managment/update-progress-status/${this.item.id}`,
          {
            progress_status: this.progress_status,
          }
        );
        this.leadStore?.updateProgressStatus(
          this.item.id,
          this.progress_status
        );
      } catch (error) {
        console.error("Error updating potentiality:", error);
      }
    },
  },
  watch: {
    item: {
      handler(newItem) {
        if (newItem && newItem.progress_status) {
          this.progress_status = newItem.progress_status;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.progress_status = this.item?.progress_status || "";
  },
};
</script>

<style scoped>
::v-deep .v-field__input {
  min-height: 32px !important;
}
::v-deep .v-select__selection-text {
  display: flex !important;
  align-items: center !important;
}
</style>
